import Type from "typebox";

export const API_VERSION = "v1" as const;
export const API_PREFIX = `/api/${API_VERSION}` as const;
export const JSON_MEDIA_TYPE = "application/json" as const;
export const PROBLEM_MEDIA_TYPE = "application/problem+json" as const;
export const SSE_MEDIA_TYPE = "text/event-stream" as const;

export const DateTimeSchema = Type.String({
  description: "RFC 3339 timestamp including an explicit UTC offset.",
  format: "date-time",
});

export const EmailAddressSchema = Type.String({
  format: "email",
  maxLength: 254,
});

export const DisplayNameSchema = Type.String({
  minLength: 1,
  maxLength: 120,
  pattern: "^\\S(?:[\\s\\S]*\\S)?$",
});

export const SafeLabelSchema = Type.String({
  minLength: 1,
  maxLength: 120,
  pattern: "^\\S(?:[\\s\\S]*\\S)?$",
});

export const RequestIdSchema = Type.String({
  minLength: 1,
  maxLength: 128,
  pattern: "^[A-Za-z0-9][A-Za-z0-9._:-]*$",
});

export const CorrelationIdSchema = Type.String({
  minLength: 1,
  maxLength: 128,
  pattern: "^[A-Za-z0-9][A-Za-z0-9._:-]*$",
});

export const RevisionSchema = Type.Integer({
  minimum: 1,
  description: "Monotonic resource revision used for optimistic concurrency.",
});

export const SecretWriteSchema = Type.String({
  minLength: 1,
  maxLength: 16_384,
  writeOnly: true,
  description: "Write-only secret plaintext. It must never appear in read or list responses.",
});

export const ONE_TIME_SECRET_EXTENSION = "x-webyonetim-one-time-secret" as const;

export const OneTimeSecretSchema = Type.String({
  minLength: 1,
  maxLength: 16_384,
  writeOnly: true,
  [ONE_TIME_SECRET_EXTENSION]: true,
  description: "Returned once by the creating mutation and never retrievable afterwards.",
});

export type DateTime = Type.Static<typeof DateTimeSchema>;
export type EmailAddress = Type.Static<typeof EmailAddressSchema>;
export type RequestId = Type.Static<typeof RequestIdSchema>;
export type CorrelationId = Type.Static<typeof CorrelationIdSchema>;
export type Revision = Type.Static<typeof RevisionSchema>;
